// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"560":"9a8568d2a8031b77","701":"9a8568d2a8031b77","702":"9a8568d2a8031b77","714":"9a8568d2a8031b77","888":"816af7821f756d99"}[chunkId] + ".css";
};